var IpcSmdPadGeneratorData = require('./ipcSmdPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var RectangleData = require('../../../svg/rectangleData.js');
var PadData = require('../../padData.js');
var ThermalPadstackData = require('../../../padstack/thermalPadstackData.js');

var IpcSmdPadGeneratorWithThermalPadData = function(position, angle, init) {
    IpcSmdPadGeneratorData.apply(this, arguments);

    //thermal pad
    this.hasThermalPad = this.value("hasThermalPad", true);
    this.thermalPadLength = this.value("thermalPadLength", true);
    this.thermalPadWidth = this.value("thermalPadWidth", true);
    this.thermalPadSolderPasteStencilApertureGapX = this.value("thermalPadSolderPasteStencilApertureGapX", true);
    this.thermalPadSolderPasteStencilApertureGapY = this.value("thermalPadSolderPasteStencilApertureGapY", true);
    this.thermalPadSolderPasteStencilApertureLength = this.value("thermalPadSolderPasteStencilApertureLength", true);
    this.thermalPadSolderPasteStencilApertureWidth = this.value("thermalPadSolderPasteStencilApertureWidth", true);
    this.thermalPadSolderPasteStencilRowCount = this.value("thermalPadSolderPasteStencilRowCount", true);
    this.thermalPadSolderPasteStencilColCount = this.value("thermalPadSolderPasteStencilColCount", true);
    this.thermalPadSolderPasteOverride = this.value("thermalPadSolderPasteOverride", true);

    this.update3dModelNonTriggerList.push("thermalPadSolderPasteOverride");
    this.update3dModelNonTriggerList.push("thermalPadSolderPasteStencilApertureGapX");
    this.update3dModelNonTriggerList.push("thermalPadSolderPasteStencilApertureGapY");
    this.update3dModelNonTriggerList.push("thermalPadSolderPasteStencilApertureLength");
    this.update3dModelNonTriggerList.push("thermalPadSolderPasteStencilApertureWidth");
    this.update3dModelNonTriggerList.push("thermalPadSolderPasteStencilRowCount");
    this.update3dModelNonTriggerList.push("thermalPadSolderPasteStencilColCount");
};

lib_core.inherit(IpcSmdPadGeneratorWithThermalPadData, IpcSmdPadGeneratorData);
lib_core.JsonParser.registerClass(IpcSmdPadGeneratorWithThermalPadData, "IpcSmdPadGeneratorWithThermalPadData");

module.exports = IpcSmdPadGeneratorWithThermalPadData;

IpcSmdPadGeneratorWithThermalPadData.prototype.setupMinMaxPtrMap = function() {
    IpcSmdPadGeneratorData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["thermalPadLength"] = [this.thermalPadLength];
    this.validationMap["thermalPadWidth"] = [this.thermalPadWidth];

};

IpcSmdPadGeneratorWithThermalPadData.prototype.getThermalPad = function(length, width) {
    var self = this;

    //the notion of length (along x-dir) is width and width (along y-dir) is height in shape data
    var shape = new RectangleData(new lib_geometry.Coord(0, 0), 0, length, width, true, 0);

    var padstack = new ThermalPadstackData(
        shape, 
        true, false, 
        true, this.thermalPadSolderPasteOverride(), 
        this.thermalPadSolderPasteStencilApertureGapX(),
        this.thermalPadSolderPasteStencilApertureGapY(), 
        this.thermalPadSolderPasteStencilApertureLength(),
        this.thermalPadSolderPasteStencilApertureWidth(), 
        this.thermalPadSolderPasteStencilRowCount(), 
        this.thermalPadSolderPasteStencilColCount());

    var pad = new PadData(new lib_geometry.Coord(0, 0), 0, "__thermalPad__", padstack, true);
    return pad;
};
